'use client'

import { useTranslations } from 'next-intl'
import { PlatformHeader } from '@/components/header/platform-header'

/**
 * The app header's title on the flows gallery: the selected pill's name, as
 * a flow page's `Flows / …` crumb reads. It translates on the client with
 * the app shell's catalog, so the page's static shell can carry it.
 */
export function FlowsHeader() {
  const t = useTranslations('flows')
  return <PlatformHeader title={t('title')} />
}
